import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=f575f94e&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=ts"
export * from "./BurgerMenu.vue?vue&type=script&lang=ts"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=f575f94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f575f94e",
  null
  
)

export default component.exports